/**
 * The places a person opened from the search box, per person and per set of
 * books (whereis-6). Shown before anything is typed.
 *
 * Kept on the device only, as place ids, never typed text: nothing typed into
 * the search box is stored anywhere (spec section 7). Cleared at sign-out with
 * the rest of what a shared machine must not remember.
 *
 * Outside `src/shared/whereis/` on purpose: sign-out is in the first load, and
 * the search box's own code never is.
 */
const PREFIX = 'karr.recentPlaces.';
const KEEP = 5;

function read(key: string): string[] {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list.filter((x): x is string => typeof x === 'string').slice(0, KEEP) : [];
    } catch {
        return [];
    }
}

/** `key` is `<user>:<books>`. Most recent first. */
export function recentPlaces(key: string | null): string[] {
    return key ? read(key) : [];
}

export function rememberPlace(key: string | null, placeId: string): void {
    if (!key) return;
    try {
        localStorage.setItem(PREFIX + key, JSON.stringify([placeId, ...read(key).filter((x) => x !== placeId)].slice(0, KEEP)));
    } catch { /* private mode or full storage: recents are a convenience */ }
}

/** Sign-out: every person's and every book's list on this device. */
export function forgetRecentPlaces(): void {
    try {
        for (const k of Object.keys(localStorage)) if (k.startsWith(PREFIX)) localStorage.removeItem(k);
    } catch { /* nothing to forget */ }
}
